import Services from "api/ProjectApiConsumer";

export function findAllBranches(obj) {
  return Services.branchService.findAllBranches(undefined, obj);
}

export function saveBranch(_, obj) {
  return Services.branchService.saveBranch(obj);
}
export function putBranch(obj, id) {
  return Services.branchService.putBranch(id, undefined, obj);
}

export function deleteBranch(id) {
  return Services.branchService.deleteBranch(undefined, undefined, id);
}
export function findBranchById(id) {
  return Services.branchService.findBranchById(id);
}
